import { render, staticRenderFns } from "./AccettazionePrestazioniListPage.vue?vue&type=template&id=94062dca&scoped=true"
import script from "./AccettazionePrestazioniListPage.vue?vue&type=script&lang=js"
export * from "./AccettazionePrestazioniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94062dca",
  null
  
)

export default component.exports